//NPM LIBRARIES
import React from 'react';
import PropTypes from 'prop-types';
//COMPONENTS AND UTILITIES
import AUbutton from '@gov.au/buttons';

/* DEFAULT
 * The stepNavigation component
 *
 * @param  {string}  type       - type of button
 * @param  {string}  label      - button label
 * @param  {function}  action   - function to run onclick
 */
const StepNavigation = ({type, label, action, ...attributeOptions}) => {

    const scrollTop =(event) =>{
        window.scrollTo(0, 0);
        action(event);
    }

    const generateNavigationButton = (type) => {
        switch (type) {
            case 'next':
                return (
                    <AUbutton
                        className="au-btn"
                        onClick={(e) => scrollTop(e)}
                        {...attributeOptions}>
                        {label}
                    </AUbutton>
                );
            case 'submit':
                return (
                    <AUbutton
                        id="Submit"
                        onClick={(e) => scrollTop(e)}
                        {...attributeOptions}>
                        {label}
                    </AUbutton>
                )
            default:
                return (
                    <AUbutton
                        as="secondary"
                        onClick={(e) => scrollTop(e)}
                        {...attributeOptions}>
                        {label}
                    </AUbutton>
                )
        }
    }

    return (
        generateNavigationButton(type)
    )
};

StepNavigation.propTypes = {
    type: PropTypes.string,
    label: PropTypes.string
};

StepNavigation.defaultProps = {
    label: 'Next'
}

export default StepNavigation